"use client";

import type { PipelineCandidate } from "@/lib/api/types";
import { EmptyCell } from "@/features/candidate";
import { titleCasePreserveAcronyms } from "@/lib/string/title-case";

export function LocationCell({ candidate }: { candidate: PipelineCandidate }) {
  if (!candidate.location) return <EmptyCell />;
  return (
    <span className="block truncate whitespace-nowrap text-sm text-muted-foreground">
      {titleCasePreserveAcronyms(candidate.location)}
    </span>
  );
}
